//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQTreeConfigBody from "./AQTreeConfigBody.vue";

export default {
    name: "AQTreeConfig",

    components: {
        AQTreeConfigBody
    },
    props: {
        dataTree: { type: Object, default: () => {} },
        dataForLoad: { type: Object, default: () => {} },
        hideDMPicker: { type: Boolean, default: false }
    },
    data() {
        return {
            headerData: [],
            bodyData: [],
            queryData: [],
            pathData: [],
            formData: [],
            requestResponseData: {}
        };
    },
    computed: {
        arrayForCategory() {
            return this.requestResponseData && this.requestResponseData.schema ? this.requestResponseData.schema : null;
        }
    },
    watch: {
        dataTree: {
            handler(newValue) {
                this.getAllEmbeddedFields(newValue);

                const { parentCollapse = [] } = this.$refs;
                if (parentCollapse) {
                    parentCollapse.forEach(element => element.hide());
                }
            },
            immediate: true
        }
    },
    methods: {
        getAllEmbeddedFields(requestResponseObj) {
            if (requestResponseObj.data) {
                this.requestResponseData = {};
                this.requestResponseData.definitions = requestResponseObj.data.definitions;
                this.requestResponseData.schema = this.parseDataTree(requestResponseObj.tab === "request" ? requestResponseObj.data.requests[0].fields
                    : requestResponseObj.data.responses["200"].response[0].fields);
            }
        },
        parseDataTree(data) {
            this.headerData = [];
            this.bodyData = [];
            this.queryData = [];
            this.pathData = [];
            this.formData = [];
            const allDataArray = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    switch (data[i].location) {
                        case "HEADER":
                            this.headerData.push(data[i]);
                            break;
                        case "QUERY":
                            this.queryData.push(data[i]);
                            break;
                        case "PATH":
                            this.pathData.push(data[i]);
                            break;
                        case "FORMDATA":
                            this.formData.push(data[i]);
                            break;
                        default: /* "BODY" */
                            this.bodyData.push(data[i]);
                    }
                }
                allDataArray.push(this.headerData, this.pathData, this.queryData, this.bodyData, this.formData);
            }
            return allDataArray.filter(entry => entry && entry.length);
        },
        returnTitle(value) {
            return value && value.length && value[0].location ? value[0].location : "BODY";
        }
    }
};
